<div mat-dialog-title id="email-dialog-title">
  @if (data.email) {
    {{ 'Contacts.Management.Emails.Dialog.EmailTitle' | translate: locale.language : { email: data.email} }}
  } @else {
    {{ 'Contacts.Management.Emails.Dialog.NewEmail' | translate: locale.language }}
  }
</div>
<div mat-dialog-content [attr.aria-labelledby]="'email-dialog-title'">
  <div>
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>{{ 'Contacts.Management.Emails.Email' | translate: locale.language }}</mat-label>
      <input
        matInput
        [placeholder]="'Contacts.Management.Emails.Dialog.EmailPlaceholder' | translate: locale.language"
        [formControl]="currentEmail"
        type="email" />
      @if (currentEmail.invalid && currentEmail.touched) {
        <mat-error>
          @if (currentEmail.hasError('required')) {
            {{ 'Contacts.Management.ContactInformation.Emails.EmailRequired' | translate: locale.language }}
          } @else if (currentEmail.hasError('email')) {
            {{ 'Contacts.Management.ContactInformation.Emails.EmailInvalid' | translate: locale.language }}
          }
        </mat-error>
      }
    </mat-form-field>
  </div>

  @if (data.action === 'Edit') {
    <div style="display: flex; align-items: center; flex-direction: column">
      <mat-form-field appearance="fill" class="full-width">
        <mat-label>
          {{ 'Contacts.Management.Emails.Dialog.EmailStatus' | translate: locale.language }}
          {{ currentStatus() ? statusNameMap[currentStatus()!] : '' }}
        </mat-label>
        <mat-select
          [(value)]="currentStatus"
          [disabled]="!canEditEmailStatus"
          aria-describedby="email-status-description">
          @for (status of data.availableStatuses; track status) {
            <mat-option [value]="status">
              {{ statusNameMap[status] }}
            </mat-option>
          }
        </mat-select>
        <span id="email-status-description" class="visually-hidden">
          {{ 'Contacts.Management.Emails.Dialog.EmailStatus' | translate: locale.language }}
        </span>
      </mat-form-field>

      @if (showReason()) {
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>{{ 'BackOffice.Emails.Details.Reason' | translate: locale.language }}</mat-label>
          <mat-select [(value)]="currentReason">
            @for (reason of reasons; track reason) {
              <mat-option [value]="reason">{{ reason }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>
  }

  <div mat-dialog-actions style="justify-content: flex-end">
    <button mat-raised-button mat-dialog-close [attr.aria-label]="'Close' | translate: locale.language">
      {{ 'Close' | translate: locale.language }}
    </button>
    @if (data.action !== 'View' && isEditing()) {
      <button
        [disabled]="currentEmail.invalid || !hasLoaded()"
        mat-raised-button
        color="primary"
        (click)="onSaveClick()"
        [attr.aria-label]="
          ('Save' | translate: locale.language) +
          (currentEmail.invalid || !hasLoaded()
            ? ' - ' + ('Contacts.Management.ContactInformation.Emails.EmailRequired' | translate: locale.language)
            : '')
        ">
        {{ 'Save' | translate: locale.language }}
      </button>
    }
  </div>

  <app-loading [isCircle]="false" [hasLoaded]="hasLoaded()" aria-live="polite"></app-loading>
</div>
